module.exports = __webpack_public_path__ + "446186e7369e25ad87653b12eb65f3d9.pdf";